import Navbar from "../Components/Navbar";
import Home from "../routes/Home";
import About from "../routes/About";
import Projects from "../routes/Projects";
import Contact from "../routes/Contact";

const Main = () => {
  return (
    <section className="page">
      <Navbar />
      <Home />
      <About />
      <Projects />
      <Contact />
    </section>
  );
};

export default Main;
